import React from 'react'

const ProjectTitle = (props) => {
  return (
    <h1 style={{textAlign: 'center', margin: '0.5em 0', lineHeight: '1em'}}>{props.title}<span style={{color: props.color}}>.</span></h1>
  )
}

export default ProjectTitle